function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none",
  viewBox: "0 0 12 12",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M1 2.25a.75.75 0 0 1 .75-.75 8.75 8.75 0 0 1 8.75 8.75.75.75 0 0 1-1.5 0A7.25 7.25 0 0 0 1.75 3 .75.75 0 0 1 1 2.25m0 3.5A.75.75 0 0 1 1.75 5C4.65 5 7 7.35 7 10.25a.75.75 0 0 1-1.5 0A3.75 3.75 0 0 0 1.75 6.5.75.75 0 0 1 1 5.75M2.25 11a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5",
  clipRule: "evenodd"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-realtime.svg";
export { SvgComponent as ReactComponent };